import React from 'react';
import { Code2 } from 'lucide-react';
import type { Book } from '../../../../shared/types/index.js';

interface EmbedBadgePromoCardProps {
  book: Book;
  onOpenEmbedModal?: (book: Book) => void;
}

export const EmbedBadgePromoCard: React.FC<EmbedBadgePromoCardProps> = ({
  book,
  onOpenEmbedModal,
}) => {
  return (
    <div className="p-4 rounded-2xl bg-gradient-to-r from-indigo-50/90 via-sky-50/60 to-white border border-indigo-200/80 flex flex-col sm:flex-row sm:items-center justify-between gap-3 shadow-2xs">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-indigo-600 text-white flex items-center justify-center shrink-0 shadow-xs">
          <Code2 className="w-5 h-5" />
        </div>
        <div>
          <h4 className="text-xs font-bold text-slate-900">
            Apakah Anda Penerbit atau Penulis Buku Ini?
          </h4>
          <p className="text-[11px] text-slate-500">
            Sematkan lencana <em>"Buku ini terdaftar resmi di UIBN"</em> langsung pada situs web toko atau katalog Anda.
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={() => {
          if (onOpenEmbedModal) onOpenEmbedModal(book);
        }}
        className="px-3.5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs font-bold flex items-center justify-center gap-1.5 transition shadow-xs cursor-pointer shrink-0"
      >
        <Code2 className="w-3.5 h-3.5" />
        <span>Dapatkan Widget Tersemat</span>
      </button>
    </div>
  );
};
